import { RootState } from './shared.reducer';

const defaultVal = {
  customerConfig: {
    default_store_code: 'default',
    segment_rule: 0,
    is_decision_maker: false,
    contact_id: '',
  },
  isLoading: false,
};

export const customerConfigState = (state: any | RootState) => {
  return state
    ? state.customer
      ? state.customer
      : defaultVal
    : defaultVal;
};
